import { atom } from "jotai";

export const authRedirectPath = atom<string | undefined>(undefined);
